module.exports = __webpack_public_path__ + "img/tarj2-1.286fcd84.svg";